import { useState } from 'react';

export function useAction() {
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function run(change: () => Promise<void>): Promise<boolean> {
    setPending(true);
    setError(null);
    try {
      await change();
      return true;
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'That did not work.');
      return false;
    } finally {
      setPending(false);
    }
  }

  return { pending, error, run };
}

export function ActionError({ error }: { error: string | null }) {
  return error === null ? null : (
    <p role="alert" className="notice notice-danger">
      {error}
    </p>
  );
}

export function ShownOnce(props: { label: string; value: string; onDismiss: () => void }) {
  const [copied, setCopied] = useState(false);
  return (
    <div className="notice notice-success" role="status">
      <p>
        <strong>{props.label}</strong> It is shown only now: copy it somewhere safe.
      </p>
      <code className="once">{props.value}</code>
      <div className="row">
        <button
          type="button"
          onClick={() =>
            void navigator.clipboard?.writeText(props.value).then(() => setCopied(true))
          }
        >
          {copied ? 'Copied' : 'Copy'}
        </button>
        <button type="button" className="quiet" onClick={props.onDismiss}>
          Done
        </button>
      </div>
    </div>
  );
}

export function ReadOnlyNote({ needs }: { needs: string }) {
  return (
    <p className="read-only-note">You can view this page. Changing it needs the {needs} role.</p>
  );
}
